<template>
    <div style="min-width:1279px">
        <header class="topbar-nav">
           <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">
            <nav class="navbar navbar-expand  bg-white flex2">
                <!-- 左边导航开始-->
                <ul class="navbar-nav  align-items-center">
                    <li class="nav-item ml-3" style="height:40px;line-height:40px;">
                        <h4 class="text-info2"> 数字化交互平台</h4>
                    </li>
                </ul>
                <!-- 左边导航结束-->
                <!-- 中间导航开始-->
                <ul class="navbar-nav align-items-center right-nav-link">
                    <li class="nav-item ml-1">

                    </li>
                </ul>
                <!-- 中间导航结束-->
                <!-- 右边信息开始-->
                <ul class="navbar-nav align-items-center right-nav-link">
                    <li class="nav-item dropdown-lg">
                        天气晴
                    </li>

                    <router-link to="/IBMS/eventIndex/alarmList">
                        <li class="nav-item dropdown-lg">
                            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect"
                               data-toggle="collapse"
                               data-target="#alarm2">
                                <i class="fa fa-bell-o"></i><span class="badge badge-info badge-up">{{
                                    totalNum
                                }}</span>
                            </a>
                        </li>
                    </router-link>
                    <el-popover
                            placement="top"
                            width="160">
                        <div>
                            <el-button type="text" @click="toUserInfo">用户资料</el-button>

                        </div>
                        <div>
                            <el-button type="text" @click="exit_login">退出登录</el-button>
                        </div>
                        <span class="user-profile cursor" slot="reference"><img src="../../../assets/images/admin.jpg"
                                                                                class="img-circle"
                                                                                id="img"
                                                                                alt="user avatar"></span>
                    </el-popover>
                </ul>
                <!-- 右边信息结束-->
            </nav>
        </header>
    </div>
</template>

<script>


export default {
    name: "header_nav",
    data() {
        return {
project_name: this.$store.state.project_name,
            proName: this.$store.state.ibmsProName,
            projectList: this.$store.state.project_list,
            projectId: this.$store.state.ibmsProId,
            page_num: '1',
            page_count: '10',
            objName: '',//对象名称
            alarm_type: '0',//报警类型
            totalNum: '',
            firstName: '首页',
            secondName: '',
            secondPath: '',
            activeIndex: this.$store.state.activeIndex,
            showHeader:'0'

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        handleSelect(key) {
            if (key === '8-2') {
                 this.$router.push({
                    path: '/IBMS/config/OperationConfigIndex',
                })
            }

            this.$store.commit('get_active_index', key)
        },
        //跳转至用户资料页
        toUserInfo() {
            this.$router.push({path: '/IBMS/userInfo'});

        },
        //退出登录
        exit_login() {
            // this.Cookies.remove("auth_key");
            window.sessionStorage.clear();
            // console.log(window.sessionStorage)
            this.$store.commit('get_ibmsProNameData', null)
            this.$store.commit('get_ibmsProIdData', null)
            this.$store.commit('get_user_id', null)
            this.$store.commit('get_role_id', null)
            this.$store.commit('get_role_name', null)
            this.$store.commit('get_auth_key', '')
            this.$store.commit('projectList', null)
            this.$store.commit('checkAuthList', null)
            this.$store.commit('funcList', null)
            this.$router.push({path: '/login'});
        },
    }
}
</script>

<style scoped>
/deep/ .el-input--suffix .el-input__inner {
    height: 36px;
    padding-right: 30px;
}

/deep/ .el-submenu__title {
    font-size: 15px;
    color: #303133;
    padding: 0 6px;
}

/deep/ .el-menu--horizontal > .el-menu-item {
    float: left;
    height: 50px;
    line-height: 50px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #0c8cc6;
    font-size: 15px;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid transparent;
    color: #324161;
}


/deep/ .el-breadcrumb__inner.is-link {
    font-weight: 400;
    text-decoration: none;
    transition: color .2s cubic-bezier(.645, .045, .355, 1);
    /* color: #00BCD4; */
}
#img{
  transition: all 0.8s;
  -ms-transition: all 0.8s;
}
#img:hover{
  transform: scale(1.3);
  -ms-transform: scale(1.3);
}

</style>
